import React from 'react';
import { View } from '@gin-betting/core';

import FixtureData from '../../FixtureData';
import useFixtureDataCS from './useFixtureDataCS';

interface Props {
    firstIcon: JSX.Element | null;
    secondIcon: JSX.Element | null;
    sportEvent: View.Match;
    withDate: boolean;
}

const FixtureDataCS: React.FC<Props> = ({
    firstIcon,
    secondIcon,
    sportEvent,
    withDate,
}) => {
    const { text: CSText, subText: CSSubtext } = useFixtureDataCS({
        sportEvent,
        withDate,
    });

    return (
        <FixtureData
            firstIcon={firstIcon}
            secondIcon={secondIcon}
            text={CSText}
            subText={CSSubtext}
        />
    );
};

export default FixtureDataCS;
